import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/base.css';
import {
    Input,
    Carousel,
    CarouselItem,
    Tabs,
    TabPane,
    Button,
    Breadcrumb,
    BreadcrumbItem,
    Pagination,
    Empty,
    Table,
    TableColumn,
    Submenu,
    RadioGroup,
    RadioButton,
    Menu,
    MenuItem,
    MenuItemGroup,
    Loading,
    Form,
    FormItem,
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {
    api
} from '@/require/api'
import {
    localStorage
} from '@/require/auth'

Vue.config.productionTip = false
const Top = () =>
    import ("@/components/Top");
const Footer = () =>
    import ("@/components/Footer");
Vue.component("Top", Top)
Vue.component("Footer", Footer)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Pagination)
Vue.use(Empty)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Submenu)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Loading)
Vue.use(Form)
Vue.use(FormItem)
Vue.prototype.$api = api;
Vue.prototype.$localStorage = localStorage;

import VueMarquee from 'vue-marquee-component';
Vue.use(VueMarquee);

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')